import { Box, Link } from "@repo/ui";

type QuestionNumberProp = {
  value: number;
  color: "attempted" | "not-answered" | "not-attempted" | "current";
};
const QuestionNumber = (props: QuestionNumberProp) => {
  const { value = 0, color = "not-attempted" } = props;

  const bgColor = {
    attempted: "bg-emerald-600",
    "not-answered": "bg-orange-200",
    "not-attempted": "bg-slate-200",
    current: "bg-blue-300",
  };
  return (
    <Box
      className={`${bgColor[color]} size-10 rounded items-center justify-center flex p-2.5`}
    >
      <Link className="!no-underline text-center">{value}</Link>
    </Box>
  );
};

export default QuestionNumber;
